import {
  ADD_INCOME_DATA,
  ADD_ALL_INCOME_DATA,
  ADD_INCOME_COUNT,
  ADD_INCOME_TOTAL,
  RESET_INCOME,
  SET_PAN_LIST,
  IS_EARNING,
  SET_DATE_LIST,
} from "./actions";

const initialState = {
  incomeInfo: {
    earningMember: true,
    membersList: [],
  },
  count: 0,
  total: 0,
  panList: {},
  dateList: {},
};

const IncomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_INCOME_DATA:
      let data = state.incomeInfo;
      // data[action.data.type] = action.data.value;
      // for(let i in action.data){
      if(action.data.length >0){
        data.membersList = [...action.data];
      }
      // }
      return {
        ...state,
        incomeInfo: { ...data },
      };
    case IS_EARNING:
      let data6 = state.incomeInfo;

      data6.earningMember = action.data;
      // }
      return {
        ...state,
        incomeInfo: { ...data6 },
      };
    case ADD_ALL_INCOME_DATA:
      let data2 = state.incomeInfo;
      // data[action.data.type] = action.data.value;
      // for(let i in action.data){

      data2 = { ...action.data };
      // }
      return {
        ...state,
        incomeInfo: { ...data2 },
      };
    case ADD_INCOME_COUNT:
      let data3 = state.count;
      data3 = action.data;
      return {
        ...state,
        count: data3,
      };
    case SET_PAN_LIST:
      let data5 = state.panList;
      data5 = action.data;
      return {
        ...state,
        panList: data5,
      };
    case SET_DATE_LIST:
      if (!state.dateList) {
        state = { ...state, dateList: {} };
      }
      // let data7 = state.dateList;
     
      //   state.dateList[action.data[0]]=state.dateList[action.data[1]]
      // }else{

      // }
      state.dateList[action.data[0]] = action.data[1];
      let dateList = state.dateList;
      // state.dateList = [...state.dateList,action.data];
      return {
        ...state,
        dateList: dateList,
      };
    case ADD_INCOME_TOTAL:
      let data4 = state.total;
      data4 = action.data;
      return {
        ...state,
        total: data4,
      };

    case RESET_INCOME:
      return initialState;
    default:
      return state;
  }
};
export default IncomeReducer;
